/*
Using day.js format string options: https://day.js.org/docs/en/display/format
Note: the dayOfWeekAsNumber format is 0-6 (0=Sunday, 6=Saturday) 
*/

export const dateFormats = {
  dayAsSingleNumber: "D",
  dayAsTwoDigitNumber: "DD",
  dayOfWeekAbbreviatedThreeCharacters: "ddd",
  dayOfWeekAbbreviatedTwoCharacters: "dd",
  dayOfWeekAsNumber: "d",
  dayOfWeekFullName: "dddd",
  default: "MM/DD/YYYY",
  fullMonthDayFullYear: "MMMM D, YYYY",
  iso: "YYYY-MM-DD",
  monthAbbreviated: "MMM",
  monthAsSingleNumber: "M",
  monthAsTwoDigitNumber: "MM",
  monthFullName: "MMMM",
  twelveHourTimeWithMinutesAMPM: "h:mm A",
  yearFourDigits: "YYYY",
  yearTwoDigits: "YY",
};
